<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select  v-model='theCmId' @change="theCmidChange" size="small"  placeholder="请选择类型">
          <el-option :value="1" label="案列分享"></el-option>
           <el-option :value="3" label="你问我答"></el-option>
        </el-select>
        <el-input
          v-model="getCircleLetterList_data.clTitle"
          placeholder="请输入帖子标题"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getCircleLetterList_data.clContext"
          placeholder="请输入帖子内容"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getCircleLetterList_data.userName"
          placeholder="请输入发布者"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getCircleLetterList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getCircleLetterList'
      api='getCircleLetterList'
      updateapi='updateCircleLetter'
      :height="H-165" >
      <icol slot='clHtml' slot-scope='{row}' show-overflow-tooltip>
        <div v-html="row.clHtml"></div>
      </icol>
    </mytable>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theCmId:null,
      csAttrId: null,
      theProjectId:"",
      theUserProject:"",
      tableColums_getCircleLetterList: {
        $selection: false,

        userName: '发布者',

        clTitle: '标题',

        clContent: '内容',

        clHtml: '富文本内容',

        createtime: '创建时间',
        $operation: [
          '操作', 120,
          this.deleteCircleLetter && `@text: 删除#danger
           @click: _confirm('确定删除吗?')
                   .trigger('deleteCircleLetter',{clId:$row.clId})
                   .trigger('getCircleLetterList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    theCmidChange(e){
      this.theCmId = e;
      this.getCircleLetterList({projectId:this.theProjectId,cmId:this.theCmId})
    },
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getCircleLetterList({projectId:this.theProjectId,cmId:1});
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getCircleLetterList({projectId:this.theProjectId,cmId:1});
    this.theCmId = 1
  },
  mounted(){

  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/discoveries/QuestionManage.vue